import axios from 'axios'
import { useFormik, FormikProvider } from 'formik'
import { useState, useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'
import { Loader } from '@components/Loader'
import { TextArea } from '@fields/TextArea'
import { useOnClickOutside } from '@hooks/use-click-outside'

import { defaultInitialValues as initialValues } from './constants'
import { PopupThird } from './PopupThird'
import {
  Popup,
  CalendarText,
  ButtonSubmit,
  Wrap,
  ContentWrapperForm,
  ButtonBack,
  ButtonForm,
  WrapStep,
  InputWrap,
  ContWrapDiv,
  Label,
  ContWithFlex,
  PopUpSecondForm,
  CloseBtn,
  ButtonEdit,
  CalendarPeronalInfo,
  Input,
  WrapperPopUp,
} from './styles'
import { validationSchema } from './validationShema'

export function PopupForm({ modalBookCall, handleClose, handleBack }) {
  const [isSend, setIsSend] = useState(false)
  const [pending, setPending] = useState(false)

  const bookCallWrapperRef = useRef()

  const closePopUp = event => {
    handleClose()
    event.stopPropagation()
  }

  const formik = useFormik({
    initialValues,
    onSubmit: async data => {
      const formData = new FormData()

      setPending(true)

      formData.set('name', data.name)
      formData.set('lastName', data.lastName)
      formData.set('email', data.email)
      formData.set('comment', data.comment)
      formData.set('duration', data.duration)
      formData.set('date', data.date)
      formData.set('timeZone', data.timeZone)
      const resData = await axios({
        method: 'post',
        url: `/api/consultation-calls`,
        data: {
          name: data.name,
          lastName: data.lastName,
          email: data.email,
          comment: data.comment,
          duration: sessionStorage.getItem('duration'),
          date: sessionStorage.getItem('selected'),
          timeZone: sessionStorage.getItem('timeZone'),
        },
      })

      setIsSend(true)
      setPending(false)

      sessionStorage.removeItem('name')
      sessionStorage.removeItem('lastName')
      sessionStorage.removeItem('email')
      sessionStorage.removeItem('comment')
      sessionStorage.setItem('data', JSON.stringify(resData.data.data))
      sessionStorage.removeItem('time')
      sessionStorage.removeItem('duration')
    },
    validationSchema,
  })

  const { handleSubmit, setFieldValue } = formik

  useEffect(() => {
    setFieldValue('name', sessionStorage.getItem('name') ?? '')
    setFieldValue('lastName', sessionStorage.getItem('lastName') ?? '')
    setFieldValue('email', sessionStorage.getItem('email') ?? '')
    setFieldValue('comment', sessionStorage.getItem('comment') ?? '')
  }, [])

  const dateUser = new Date(sessionStorage.getItem('userDuration'))
  const backToForm = () => {
    const { name, lastName, email, comment } = formik.values
    sessionStorage.setItem('name', name)
    sessionStorage.setItem('lastName', lastName)
    sessionStorage.setItem('email', email)
    sessionStorage.setItem('comment', comment)
    handleBack()
  }

  const resetAction = event => {
    event.stopPropagation()
  }

  return createPortal(
    <WrapperPopUp>
      <PopUpSecondForm onClick={closePopUp}>
        <FormikProvider value={formik}>
          <ContentWrapperForm onSubmit={handleSubmit} onClick={resetAction}>
            <PopUpSecondForm>
              {!isSend ? (
                <Popup ref={bookCallWrapperRef}>
                  <WrapStep>
                    <ContWrapDiv>step 0{modalBookCall}/03</ContWrapDiv>
                    <CloseBtn onClick={handleClose}>Close</CloseBtn>
                  </WrapStep>
                  <WrapStep />
                  <Wrap className="personal-info">
                    <CalendarText>Fill in your personal info:</CalendarText>
                    <CalendarPeronalInfo>
                      {dateUser.toLocaleString('en-US', {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour12: false,
                        hour: ['numeric'],
                        minute: ['numeric'],
                      })}
                      <ButtonEdit onClick={backToForm}>
                        Edit
                        <ImageWithPlaceholder
                          width="15"
                          height="15"
                          alt="pencil"
                          src="/images/pencil-version-2.webp"
                        />
                      </ButtonEdit>
                    </CalendarPeronalInfo>
                  </Wrap>

                  <Wrap>
                    <ContWrapDiv>
                      <ContWithFlex>
                        <InputWrap>
                          <Input name="name" placeholder="First Name" />
                        </InputWrap>
                        <InputWrap>
                          <Input name="lastName" placeholder="Last Name" />
                        </InputWrap>
                      </ContWithFlex>
                    </ContWrapDiv>
                    <ContWrapDiv>
                      <Label>Email address:</Label>
                      <ContWithFlex>
                        <InputWrap>
                          <Input name="email" placeholder="E-mail" />
                        </InputWrap>
                      </ContWithFlex>
                    </ContWrapDiv>
                    <ContWrapDiv>
                      <Label>Add a commentary:</Label>
                      <ContWithFlex>
                        <InputWrap className="comment-text">
                          <TextArea
                            name="comment"
                            className="comment"
                            placeholder="Add your text..."
                            errorMsgVariant="errorWhiteBG"
                          />
                        </InputWrap>
                      </ContWithFlex>
                    </ContWrapDiv>

                    <ButtonForm>
                      <ContWrapDiv>
                        <ButtonBack onClick={backToForm}>Back</ButtonBack>
                      </ContWrapDiv>
                      <ContWrapDiv>
                        <ButtonSubmit type="submit">
                          {pending ? <Loader /> : 'Submit'}
                        </ButtonSubmit>
                      </ContWrapDiv>
                    </ButtonForm>
                  </Wrap>
                </Popup>
              ) : (
                <PopupThird handleClose={handleClose} />
              )}
            </PopUpSecondForm>
          </ContentWrapperForm>
        </FormikProvider>
      </PopUpSecondForm>
    </WrapperPopUp>,
    document.body
  )
}
